"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelForWindowPickerOption = exports.granularityFromWindow = exports.displayStringFromWindow = exports.displayDateWindow = void 0;
var localization_1 = require("../../../localization");
var core_1 = require("../core");
var models_1 = require("../../../models");
var dateFormatter_1 = require("../../../formatting/dateFormatter");
var displayDateWindow = function (dateWindow) {
    return (0, exports.displayStringFromWindow)(dateWindow);
};
exports.displayDateWindow = displayDateWindow;
var displayStringFromWindow = function (window) {
    var granularity = (0, exports.granularityFromWindow)(window);
    if (!granularity) {
        if (window.type === core_1.DateWindowTypes.CUSTOM || window.type === core_1.DateWindowTypes.DEFINED_START) {
            return localization_1.Messages.metricsCustomStartDateOption();
        }
    }
    else if (window.type === core_1.DateWindowTypes.LAST_N) {
        var n = window.n;
        return rangeStringForGranularity(granularity, n);
    }
    else if (window.type === core_1.DateWindowTypes.LATEST_DATA) {
        var n = window.duration.numberOfUnits;
        return rangeStringForGranularity(granularity, n);
    }
    return localization_1.Messages.metricsDateRangeAllTime();
};
exports.displayStringFromWindow = displayStringFromWindow;
var rangeStringForGranularity = function (granularity, n) {
    switch (granularity) {
        case models_1.DateTrunc.SECOND: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeSecondSingular()
                : localization_1.Messages.metricsDateRangeSecondPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.MINUTE: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeMinuteSingular()
                : localization_1.Messages.metricsDateRangeMinutePlural({ num: n.toString() });
        }
        case models_1.DateTrunc.HOUR: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeHourSingular()
                : localization_1.Messages.metricsDateRangeHourPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeDaySingular()
                : localization_1.Messages.metricsDateRangeDayPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.MONTH: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeMonthSingular()
                : localization_1.Messages.metricsDateRangeMonthPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeWeekSingular()
                : localization_1.Messages.metricsDateRangeWeekPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeQuarterSingular()
                : localization_1.Messages.metricsDateRangeQuarterPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeYearSingular()
                : localization_1.Messages.metricsDateRangeYearPlural({ num: n.toString() });
        }
        case models_1.DateTrunc.NONE: {
            return localization_1.Messages.metricsDateRangeAllTime();
        }
        case models_1.DateTrunc.UNKNOWN:
        default: {
            return n === 1
                ? localization_1.Messages.metricsDateRangeByMarkSingular()
                : localization_1.Messages.metricsDateRangeByMarkPlural({ num: n.toString() });
        }
    }
};
var granularityFromWindow = function (window) {
    // make it so that with new types of windows we don't have to add much more logic
    switch (window.type) {
        case core_1.DateWindowTypes.LAST_N:
            return models_1.DateTrunc.UNKNOWN;
        case core_1.DateWindowTypes.LATEST_DATA:
            return window.duration.unit;
        // our only "special" window at the moment is ALLTIME
        // this is likely to change in the future
        case core_1.DateWindowTypes.SPECIAL:
        case core_1.DateWindowTypes.CUSTOM:
        case core_1.DateWindowTypes.DEFINED_START:
        default:
            return undefined;
    }
};
exports.granularityFromWindow = granularityFromWindow;
function exhaustivelyMatch(_) {
    throw 'Should not reach here';
}
var getLabelForWindowPickerOption = function (window) {
    switch (window.type) {
        case core_1.DateWindowTypes.DEFINED_START:
            return (0, dateFormatter_1.windowPickerStartDate)(window.startDate);
        case core_1.DateWindowTypes.SPECIAL:
            return localization_1.Messages.metricsDateRangeAllTime();
        case core_1.DateWindowTypes.LAST_N:
            return (0, dateFormatter_1.abbreviatedRelativeDateWindow)(models_1.DateTrunc.UNKNOWN, window.n);
        case core_1.DateWindowTypes.LATEST_DATA:
            return (0, dateFormatter_1.abbreviatedRelativeDateWindow)(window.duration.unit, window.duration.numberOfUnits);
        case core_1.DateWindowTypes.CUSTOM:
            return (0, dateFormatter_1.dateFormatterFactory)(models_1.DateTrunc.UNKNOWN).dateRangeSlashFormat(window.range.first, window.range.last);
        default:
            exhaustivelyMatch(window);
    }
};
exports.getLabelForWindowPickerOption = getLabelForWindowPickerOption;
//# sourceMappingURL=displayDateWindow.js.map